<template>
  <AreaHomeContactUsMain />
  <NewsletterSection />
</template>
